<template>
  <div>
   <vx-card v-if="firstChapterEmpty">
      <div>
      <div class="">


        <h3 class="font-black">let's start the journey</h3>
        <!-- <h4>Every timeline needs a beginning; when starts yours?</h4> -->

        <div class="mt-2">
          „Who you are tomorrow begins with what you do today.“ — Tim Fargo
        </div>

        <div class="flex justify-center">
          <vs-button icon-pack="feather" icon="icon-compass" @click.stop="openFirstChapter" class="mt-4 shadow-2xl text-center" :class="{'animate-bounce': $route.query.embraceJourney, 'cursor-not-allowed': $store.getters.isAnonymous}" :disabled="$store.getters.isAnonymous">
          embrace the journey
          </vs-button>
        </div>

                  <div class="flex flex-wrap justify-center font-italic hover:underline">
            <span v-if="$store.getters.isAnonymous" class="text-center cursor-pointer" @click="register">

            *you need to register first</span>
            <!-- <p v-else class="text-center">free for improvee.io users</p> -->
           </div>

        </div>

      </div>
    </vx-card>
    <div v-else>
      <FirstChapterText :firstChapter="firstChapter"/>
    </div>

 <vs-popup fullscreen title="" :active.sync="popupActive">

      <div class="md:flex md:px-8 md:pb-16 md:h-screen ">
        <div class="md:w-1/2 flex flex-wrap content-center justify-start w-full text-dark">

          <h2 class="w-full text-5xl md:text-6xl font-bold">the first chapter</h2>

          <p class="mt-4 text-lg ">From small beginnings come great things. How does your beginning looks like?</p>

          <p class="mt-4 text-lg font-bold">Reflect on your current self; how satisfied are you with certain areas of your life?</p>

          <div class="w-full flex justify-center mt-4">
            <img class="w-3/5" src="@/assets/images/onboarding/starting_point.png"/>
          </div>
        </div>

        <div class="flex flex-wrap content-center text-center justify-center md:w-1/2 md:text-left md:justify-start">

          <div class="md:flex w-full justify-center">
            <div class="flex w-full">
              <FirstChapterItem v-model="firstChapterLocal.work" icon="BriefcaseIcon" title="Work" class="m-3"/>
            </div>
            <div class="flex w-full">
              <FirstChapterItem v-model="firstChapterLocal.wealth" icon="DollarSignIcon" title="Wealth" class="m-3"/>
            </div>
          </div>

          <div class="md:flex w-full justify-center">
            <div class="flex w-full">
              <FirstChapterItem v-model="firstChapterLocal.spirituality" icon="SunriseIcon" title="Spirituality" class="m-3"/>
            </div>
            <div class="flex w-full">
              <FirstChapterItem v-model="firstChapterLocal.health" icon="ActivityIcon" title="Health" class="m-3"/>
            </div>
          </div>
          <div class="md:flex w-full justify-center">
            <div class="flex w-full">
              <FirstChapterItem v-model="firstChapterLocal.growth" icon="BookIcon" title="Growth" class="m-3"/>
            </div>
            <div class="flex w-full">
              <FirstChapterItem v-model="firstChapterLocal.relationships" icon="HeartIcon" title="Relationships" class="m-3"/>
            </div>
          </div>

          <div class="md:flex w-full justify-center">
            <div class="flex w-full">
              <FirstChapterItem v-model="firstChapterLocal.play" icon="UsersIcon" title="Play" class="m-3"/>
            </div>
            <div class="flex w-full">
              <FirstChapterItem v-model="firstChapterLocal.environment" icon="ImageIcon" title="Environment" class="m-3"/>
            </div>
          </div>

          <div class="flex w-full justify-end mt-4">
            <span class="text-gray font-sm">
              It's essential to have a starting point, so you can see the progress you will make.
            </span>
          </div>

          <div class="flex w-full justify-end mt-4">
            <vs-button @click="saveFirstChapter" :disabled="disabled">
              {{saveButtonText}}
            </vs-button>
          </div>

        </div>
      </div>
    </vs-popup>
  </div>

</template>

<script>
import * as DateHelper from '@/helpers/date'
import FirstChapterItem from './FirstChapterItem'
import FirstChapterText from './FirstChapterText'
export default {
  components: {
    FirstChapterItem,
    FirstChapterText
  },
  props: {

  },
  data () {
    return {
      popupActive: false,
      disabled: true,
      firstChapterLocal: {
        work: null,
        wealth: null,
        spirituality: null,
        health: null,
        growth: null,
        relationships: null,
        play: null,
        environment: null
      }
    }
  },
  computed: {
    firstChapterEmpty () {
      return !this.firstChapter
    },
    firstChapter () {
      return this.$store.getters.firstChapter
    },
    userRegisteredAt () {
      return DateHelper.midnight(this.$store.getters.userRegisteredAt)
    },
    saveButtonText () {
      if (this.ratedCount < 8) {
        return `rate all areas of your life (${8 - this.ratedCount})`
      } else {
        return 'save my starting point'
      }
    },
    ratedCount () {
      let ratedCount = 0

      if (this.firstChapterLocal.work) {
        ratedCount = ratedCount + 1
      }

      if (this.firstChapterLocal.wealth) {
        ratedCount = ratedCount + 1
      }

      if (this.firstChapterLocal.spirituality) {
        ratedCount = ratedCount + 1
      }

      if (this.firstChapterLocal.health) {
        ratedCount = ratedCount + 1
      }

      if (this.firstChapterLocal.growth) {
        ratedCount = ratedCount + 1
      }

      if (this.firstChapterLocal.relationships) {
        ratedCount = ratedCount + 1
      }

      if (this.firstChapterLocal.play) {
        ratedCount = ratedCount + 1
      }

      if (this.firstChapterLocal.environment) {
        ratedCount = ratedCount + 1
      }

      return ratedCount
    }
  },
  watch: {
    'firstChapterLocal.work': { immediate: false, handler () { this.enableButton() } },
    'firstChapterLocal.wealth': { immediate: false, handler () { this.enableButton() } },
    'firstChapterLocal.spirituality': { immediate: false, handler () { this.enableButton() } },
    'firstChapterLocal.health': { immediate: false, handler () { this.enableButton() } },
    'firstChapterLocal.growth': { immediate: false, handler () { this.enableButton() } },
    'firstChapterLocal.relationships': { immediate: false, handler () { this.enableButton() } },
    'firstChapterLocal.play': { immediate: false, handler () { this.enableButton() } },
    'firstChapterLocal.environment': { immediate: false, handler () { this.enableButton() } },
  },
  methods: {
    register () {
      this.$router.push('/login').catch(() => {})
    },
    enableButton () {
      this.disabled = !(this.firstChapterLocal.work &&
      this.firstChapterLocal.wealth &&
      this.firstChapterLocal.spirituality &&
      this.firstChapterLocal.health &&
      this.firstChapterLocal.growth &&
      this.firstChapterLocal.relationships &&
      this.firstChapterLocal.play &&
      this.firstChapterLocal.environment)
    },
    openFirstChapter () {
      this.popupActive = true
    },
    saveFirstChapter () {
      this.$store.dispatch('SET_FIRST_CHAPTER', this.firstChapterLocal)
      this.$store.dispatch('ADDITIONAL_USER_INFO', { firstChapterFilled: true })
      this.popupActive = false
    }
  }
}
</script>

<style>
</style>
